/* ActivityFeed — right-rail variant used on the People detail page.
 * Shape mirrors <NewsTicker/> so the rail looks consistent across
 * entity types, but the source is audit_log (private to the firm)
 * not entity_news (public web items).
 */
import React from 'react';
import { Icon } from './primitives.jsx';

function relTime(value) {
  if (!value) return '';
  const ms = typeof value === 'number' ? value : Date.parse(value);
  if (!Number.isFinite(ms)) return '';
  const diff = Date.now() - ms;
  const min = 60_000, hr = 60 * min, day = 24 * hr;
  if (diff < hr)     return `${Math.max(1, Math.round(diff / min))}m ago`;
  if (diff < day)    return `${Math.round(diff / hr)}h ago`;
  if (diff < 30*day) return `${Math.round(diff / day)}d ago`;
  return new Date(ms).toISOString().slice(0, 10);
}

// Translate dotted audit actions into human-readable phrases.
function humanAction(action) {
  if (!action) return '';
  const map = {
    'login':              'signed in',
    'logout':             'signed out',
    'chat.created':       'started a chat',
    'chat.replied':       'sent a chat message',
    'profile.updated':    'updated their profile',
    'project.created':    'created a project',
    'project.updated':    'updated a project',
    'project.deleted':    'deleted a project',
    'client.created':     'created a client',
    'service.created':    'added a service',
    'industry.created':   'added an industry',
    'function.created':   'created a role',
    'function.evaluated': 'evaluated a role',
    'skill.created':      'created a skill',
    'skill.updated':      'updated a skill',
    'skill.deleted':      'deleted a skill',
    'invitation.issued':  'invited someone',
    'invitation.revoked': 'revoked an invite',
    'agent.run':          'ran an agent',
  };
  return map[action] || action.replace(/\./g, ' · ');
}

export const ActivityFeed = ({ items }) => {
  return (
    <aside className="news-ticker">
      <div className="news-ticker__head">
        <Icon name="time" size={14}/>
        <strong>Recent activity</strong>
        <span style={{color:'var(--fg-muted)',fontSize:11,marginLeft:'auto'}}>
          last 30 days
        </span>
      </div>

      {!items && (
        <div style={{padding:14,color:'var(--fg-muted)',fontSize:12.5}}>Loading…</div>
      )}

      {items && items.length === 0 && (
        <div style={{padding:'12px 14px',color:'var(--fg-muted)',fontSize:12.5,lineHeight:1.5}}>
          No tracked activity in the last 30 days. Most user actions in eOS are logged to <code>audit_log</code>; the feed will populate as soon as this person edits, runs, or creates anything.
        </div>
      )}

      {items && items.length > 0 && (
        <ul className="news-ticker__list">
          {items.map(it => (
            <li key={it.id} className="news-ticker__item">
              <div style={{fontSize:12.5,lineHeight:1.45}}>
                <span style={{fontWeight:500}}>{humanAction(it.action)}</span>
                {it.targetLabel && (
                  <> · <span style={{color:'var(--fg-muted)'}}>{it.targetLabel}</span></>
                )}
              </div>
              <div className="news-ticker__meta">
                {relTime(it.createdAt)}
                {it.targetType ? <> · {it.targetType}</> : null}
              </div>
              {it.detailsPreview && (
                <div className="news-ticker__summary">{it.detailsPreview}</div>
              )}
            </li>
          ))}
        </ul>
      )}
    </aside>
  );
};
